var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": "",
      "rounded": "",
      "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    }
  }, [_vm.clearance.title ? _c('v-card-subtitle', [_vm._v(_vm._s(_vm.clearance.title))]) : _vm._e(), _c('v-card-text', [_c('v-row', {
    staticClass: "mb-2",
    attrs: {
      "dense": ""
    }
  }, [_vm.sellerCompanyName ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.company'),
      "value": _vm.sellerCompanyName,
      "hide-details": "",
      "readonly": ""
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('created'),
      "hide-details": "",
      "readonly": ""
    },
    model: {
      value: _vm.clearance.timestamp.createdReadable,
      callback: function callback($$v) {
        _vm.$set(_vm.clearance.timestamp, "createdReadable", $$v);
      },
      expression: "clearance.timestamp.createdReadable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('clearanceApproval.clearanceSumTitle'),
      "value": (_vm.clearance.totalNet || 0).toLocaleString('de-DE', {
        style: 'currency',
        currency: _vm.clearance.currency
      }),
      "hide-details": "",
      "readonly": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm.canUpdateClearance ? _c('select-assignees', {
    attrs: {
      "css": "width: 100%",
      "partnerId": _vm.clearance.partnerId,
      "outlined": false,
      "dense": false,
      "solo": false
    },
    on: {
      "input": _vm.onAssigneesUpdate,
      "added": _vm.onAssigneesAdded,
      "removed": _vm.onAssigneesRemoved
    },
    model: {
      value: _vm.clearance.assignees,
      callback: function callback($$v) {
        _vm.$set(_vm.clearance, "assignees", $$v);
      },
      expression: "clearance.assignees"
    }
  }) : _vm._e()], 1), _vm.clearance.isCompletedSuccessfully ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "border-card transparent-bg",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportClearanceCard.isApprovedTitle")) + " "), _c('v-spacer'), _vm.canShareContent ? _c('m-icon-button', {
    attrs: {
      "icon": "mdi-link-variant"
    },
    on: {
      "click": function click() {
        return _vm.sharedContentSideCardItem = _vm.clearance.lastSharedContent;
      }
    }
  }) : _vm._e()], 1), _vm.clearance.isSend ? _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportClearanceCard.isApprovedText")) + " ")]) : _vm._e()], 1)], 1) : !_vm.clearance.isClearanceApprovalLoading && !_vm.clearance.allApprovalsCleared ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [!_vm.clearance.isClearanceApprovalLoading && !_vm.clearance.allApprovalsCleared ? _c('v-checkbox', {
    attrs: {
      "dense": "",
      "label": _vm.$t('components.PartnerReportDetail.repair.PartnerReportClearanceCard.byPass')
    },
    model: {
      value: _vm.isByPassRules,
      callback: function callback($$v) {
        _vm.isByPassRules = $$v;
      },
      expression: "isByPassRules"
    }
  }) : _vm._e(), _c('v-btn', {
    attrs: {
      "disabled": !_vm.isByPassRules || _vm.clearance.isClearanceApprovalLoading,
      "block": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.isUpdateStatusDialogOpen = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportClearanceCard.approve")) + " ")])], 1) : _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.clearance.isClearanceApprovalLoading,
      "block": "",
      "color": "primary",
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        _vm.isUpdateStatusDialogOpen = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportClearanceCard.approve")) + " ")])], 1)], 1), _c('v-divider'), _c('m-expansion', {
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportClearanceCard.approvals", {
          amount: _vm.clearance.clearanceApprovalIds.length
        })) + " ")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showClearanceApprovals,
      callback: function callback($$v) {
        _vm.showClearanceApprovals = $$v;
      },
      expression: "showClearanceApprovals"
    }
  }, [_vm.clearance.isClearanceApprovalLoading ? _c('div', _vm._l(_vm.clearance.clearanceApprovalIds.length, function (n) {
    return _c('v-skeleton-loader', {
      key: n,
      staticClass: "mb-2",
      attrs: {
        "type": "image",
        "height": "88"
      }
    });
  }), 1) : _c('div', _vm._l(_vm.clearance.clearanceApprovals, function (clearanceApproval) {
    return _c('clearance-approval-sheet', {
      key: 'clearanceApproval-' + clearanceApproval.id,
      staticClass: "mb-2",
      attrs: {
        "report": _vm.report,
        "rounded": "",
        "clearanceApproval": clearanceApproval
      }
    });
  }), 1)]), _c('report-clearance-update-status-dialog', {
    attrs: {
      "clearance": _vm.clearance
    },
    model: {
      value: _vm.isUpdateStatusDialogOpen,
      callback: function callback($$v) {
        _vm.isUpdateStatusDialogOpen = $$v;
      },
      expression: "isUpdateStatusDialogOpen"
    }
  })], 1), _vm.sharedContentSideCardItem ? _c('shared-content-side-card', {
    attrs: {
      "value": _vm.sharedContentSideCardItem,
      "referenceCategories": [_vm.ResourceEnum.DOCUMENT, _vm.ResourceEnum.RENTAL, _vm.ResourceEnum.APPRAISAL, _vm.ResourceEnum.REPAIR_ESTIMATE, _vm.ResourceEnum.CLEARANCE, _vm.ResourceEnum.CLEARANCE_APPROVAL],
      "suggested": _vm.report.suggestedRefs,
      "hideSuggested": false
    },
    on: {
      "close": function close($event) {
        _vm.sharedContentSideCardItem = null;
      }
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }